var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-sticky",
    {
      ref: "sticky",
      staticStyle: { height: "56px" },
      attrs: { "auto-size": "", resizable: "", fixed: "", "keep-left": "" },
    },
    [
      _c("div", { staticClass: "gwnl-step-header" }, [
        _vm.showBack
          ? _c(
              "div",
              {
                staticClass:
                  "gwnl-step-header__back hand flex align-items-center",
                on: {
                  click: function ($event) {
                    return _vm.$emit("back-click")
                  },
                },
              },
              [
                _c("yxt-svg", {
                  staticClass: "color-gray-10 vertical-align--middle",
                  attrs: {
                    "remote-url": _vm.cdnMediaDomain + "/gwnl/pc/svg",
                    width: "16px",
                    height: "16px",
                    "icon-class": "page-header-back-arrow",
                  },
                }),
                _c("span", { staticClass: "color-gray-10 ml8 font-medium" }, [
                  _vm._v(_vm._s(this.$t("pc_gwnl_global_return"))),
                ]),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "gwnl-step-header__center text-center" },
          [_vm._t("center")],
          2
        ),
        _c(
          "div",
          { staticClass: "gwnl-step-header__right" },
          [_vm._t("right")],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }